import { ReportsSumariesView } from "./iu/reportsSumaries.view";
import { useApiPostExecuteReports } from "../../fnx/reports/postExecuteReports";
import React, { useEffect, useState } from "react";
import { ExecuteReportState } from "./resources/reportsSumaries.DTO";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCurrentMonth,
  getCurrentSemester,
  getPreviousMonth,
  getQuarterDates,
} from "../../services/getDates";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { ToastState } from "../customReportPage/resources/customReportsDTO";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../fnx/showError";
import {
  executeReportsClearData,
  reportsClearData,
} from "../../store/reports/actions";
import { useDispatch } from "react-redux";
import { formattedDateYYMMDD, newFormattedDate } from "../../utils/date";
import { useApiPostReports } from "../../fnx/reports/postReports";
import { buttonActionOptions } from "../reportsPage/completedSales/completedDTO";
import { useDownloadReportExcel } from "../../fnx/reports/reportExportExcel";

export const ReportsSummaries = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialPage = 1;
  const initialPageSize = 5000;
  const { reportId } = useParams();
  const { reportDate } = useParams();
  const [state, setState] = useState<ExecuteReportState>({
    page: initialPage,
    pageSize: initialPageSize,
    reportTrigger: false,
    expoReportTrigger: false,
    exportExcelTrigger: false,
    reportName: "",
    bodyExeReport: {
      id: "",
      params: { from: "", to: "" },
      page: initialPage,
      pageSize: initialPageSize,
    },
    bodyReport: { page: 0, pageSize: 10 },
  });
  const [toast, setToast] = useState<ToastState>({
    show: false,
    message: "",
    type: typeAlert.success,
  });
  const [columns, setColumns] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);

  const { loadingExecuteReports, responseExecuteReports, errorExecuteReports } =
    useApiPostExecuteReports(state.reportTrigger, state.bodyExeReport);

  const { loadingReports, responseReports, errorReports } = useApiPostReports(
    state.reportTrigger,
    state.bodyReport,
  );

  const { loading, error } = useDownloadReportExcel({
    trigger: state.exportExcelTrigger,
    reportBody: state.bodyExeReport,
    filename: state.reportName,
    onFinish: () =>
      setState((prev) => ({ ...prev, exportExcelTrigger: false })),
  });

  useEffect(() => {
    setState((prev) => ({ ...prev, reportTrigger: true }));
    onClickMonthReport(reportDate || "");
  }, []);

  useEffect(() => {
    if (errorExecuteReports) {
      showErrorToast(errorExecuteReports, setToast, t);
      setState((prev) => ({ ...prev, expoReportTrigger: false }));
      dispatch(executeReportsClearData());
    }
  }, [errorExecuteReports]);

  useEffect(() => {
    if (errorReports) {
      showErrorToast(errorReports, setToast, t);
      setState((prev) => ({ ...prev, expoReportTrigger: false }));
      dispatch(reportsClearData());
    }
  }, [errorReports]);

  useEffect(() => {
    if (responseExecuteReports?.length > 0) {
      const firstItem = responseExecuteReports[0];
      const columnOrder = Object.getOwnPropertyNames(firstItem);

      const columns = columnOrder.map((key) => {
        const baseColumn = {
          field: key,
          headerName: key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase()),
          width: 200,
        };

        if (key.toLowerCase().includes("fecha")) {
          return {
            ...baseColumn,
            valueFormatter: (params: any) => newFormattedDate(params.value),
          };
        }

        return baseColumn;
      });

      const rows = responseExecuteReports.map((item: any, index: any) => {
        const rowWithDefaults = { ...item };
        columnOrder.forEach((col) => {
          if (!(col in rowWithDefaults)) {
            rowWithDefaults[col] = null;
          }
        });

        if (rowWithDefaults["Prima"]) {
          const primaNumber = parseFloat(rowWithDefaults["Prima"]);
          if (!isNaN(primaNumber)) {
            rowWithDefaults["Prima"] = `RD$ ${primaNumber.toLocaleString(
              "en-US",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              },
            )}`;
          }
        }

        return {
          id: item.Cotizacion || `row-${index}`,
          ...rowWithDefaults,
        };
      });
      setColumns(columns);
      setRows(rows);
    }
    dispatch(executeReportsClearData());
  }, [responseExecuteReports]);

  useEffect(() => {
    if (responseReports?.length > 0) {
      const reportFind = responseReports.find(
        (report: any) => report.id === reportId,
      );
      setState((prev) => ({ ...prev, reportName: reportFind.name || "" }));
      dispatch(reportsClearData());
    }
  }, [responseReports, reportId]);

  const onClickMonthReport = (date: string) => {
    let startDate = "";
    let endDate = "";
    switch (date) {
      case "currentMonth":
        ({ startDate, endDate } = getCurrentMonth());
        break;
      case "prevMonth":
        ({ startDate, endDate } = getPreviousMonth());
        break;
      case "currentQuarter":
        ({ startDate, endDate } = getPreviousMonth());
        break;
      case "prevQuarter":
        ({ startDate, endDate } = getQuarterDates("previous"));
        break;
      case "currentSemester":
        ({ startDate, endDate } = getCurrentSemester());
        break;
    }
    setState((prev) => ({
      ...prev,
      bodyExeReport: {
        ...prev.bodyExeReport,
        id: reportId || "",
        params: {
          from: startDate,
          to: endDate,
        },
      },
      expoReportTrigger: true,
    }));
  };

  const onBack = () => {
    navigate("/report-quote-sales");
  };

  const onChangeFilters = (data: any) => {
    if (data && Object.keys(data).length > 0) {
      const getFormattedDate = (index: number) => {
        const isValidDateRange =
          Array.isArray(data?.dateRange) && data.dateRange.length > 0;
        if (!isValidDateRange) return "";
        const formattedDate = formattedDateYYMMDD(data?.dateRange?.[index]);
        return formattedDate === "undefined" ||
          formattedDate === "null" ||
          formattedDate === "NA"
          ? ""
          : formattedDate;
      };

      const startDate = getFormattedDate(0);
      const endDate = getFormattedDate(1);

      setState((prev) => ({
        ...prev,
        bodyExeReport: {
          ...prev.bodyExeReport,
          id: reportId || "",
          params: {
            from: startDate,
            to: endDate,
          },
        },
        expoReportTrigger: true,
      }));
    }
  };

  const onExportReport = (i: buttonActionOptions) => {
    switch (i.id) {
      case "1":
        setState((prev) => ({
          ...prev,
          exportExcelTrigger: true,
        }));
    }
  };

  const onClearFilter = () => {
    onClickMonthReport(reportDate || "");
  };

  return (
    <React.Fragment>
      <AlertLoadingHeader
        loading={loadingExecuteReports || loadingReports || loading}
        seeToast={toast}
        showToast={showToast}
        setSeeToast={setToast}
        titleLoading={"Cargando Reporte"}
      />
      <ReportsSumariesView
        columns={columns}
        rows={rows}
        onBack={onBack}
        reportName={state.reportName}
        onChangeFilter={onChangeFilters}
        onClearFilter={onClearFilter}
        onExportReport={onExportReport}
      />
    </React.Fragment>
  );
};
